// @flow
import React from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import logoPrint from 'assets/images/logo_print.png';
import imgBg from 'assets/images/background_print.png';
import { toTitleCase } from 'utils/string';

import './styles.css';

const PrintGoalcard = (props: Props) => {
  const { goalcard } = props;
  
  const executeAtDate = goalcard.executeAt ? moment(goalcard.executeAt).utc().format('MM/DD/YYYY') : undefined;

  const toTextTitle = toTitleCase(goalcard.whoIsCardFor);

  const fromTextTitle = toTitleCase(goalcard.investorFullName);

  const { t } = useTranslation();

  let wrapperClass = '';

  if (goalcard.description.length > 250) {
    wrapperClass = 'print-goalcard-full-extended-container';
  } else if (goalcard.description.length >= 150) {
    wrapperClass = 'print-goalcard-medium-extended-container';
  }

  return (
    <div className="print-goalcard">
      <div
        style={{ minHeight: '100%' }}
        className={`print-goalcard-wrapper ${wrapperClass}`}
      >
        <div className="print-goalcard-inner">
          <div className="print-goalcard-header">
            <div className="print-goalcard-logo-wrapper">
              <img
                alt="goalsetter logo"
                className="print-goalcard-logo"
                src={logoPrint}
              />
            </div>
            <h1 className="print-goalcard-heading">
              {`$ ${parseFloat(goalcard.amount).toFixed(2)}`}
            </h1>
          </div>
          <div
            className="print-goalcard-pic"
            style={{ backgroundImage: `url(${imgBg})` }}
          >
            <img alt="goalcard pic" id="cardImg" src={goalcard.goalcardImg} />
          </div>
          <div className="print-goalcard-body">
            <div className="print-goalcard-body-text">
              <div className="print-goalcard-body-info">
                <div className="print-goalcard-body-info-item to">
                  <div className="print-goalcard-body-info-item-label">
                    {t('goalcard_to')}
                  </div>
                  <div className="print-goalcard-body-info-item-value">
                    <span id="formNameTo">{toTextTitle}</span>
                  </div>
                </div>
                <div className="print-goalcard-body-info-item from">
                  <div className="print-goalcard-body-info-item-label">
                    {t('goalcard_from')}
                  </div>
                  <div className="print-goalcard-body-info-item-value">
                    <span id="formNameFrom">{fromTextTitle}</span>
                  </div>
                </div>
                <div className="print-goalcard-body-info-item for">
                  <div className="print-goalcard-body-info-item-label">
                    {t('goalcard_for')}
                  </div>
                  <div className="print-goalcard-body-info-item-value">
                    <span id="noGoalMessage">
                      {goalcard.internalDescription || t('customize_forpreset_title')}
                    </span>
                  </div>
                </div>
              </div>
              <div className="print-goalcard-body-congrats" id="divMessage">
                <h2 className="print-goalcard-body-congrats-heading">
                  {t('goalcard_hi_title')}
                  {' '}
                  <span id="messageNameTo">{toTextTitle}</span>
                  ,
                </h2>
                <p className="print-goalcard-body-congrats-par" id="message">
                  {' '}
                  {goalcard.description || t('goalcard_gotMoney')}
                </p>
                <span className="print-goalcard-body-congrats-sign">
                  <span id="messageNameFrom">{fromTextTitle}</span>
                </span>
              </div>
            </div>
            <div
              className="print-goalcard-body-photo"
              style={{ textAlign: 'center' }}
            >
              {goalcard.imageURL && (
              <img
                id="uploadedImg"
                alt="upload pic"
                src={goalcard.imageURL}
                style={{ maxWidth: '270px', maxHeight: '300px' }}
              />
              )}
            </div>
          </div>
          <div className="print-goalcard-faq">
            <h3 className="print-goalcard-faq-q">
              {t('goalsetter_whatis_title')}
            </h3>
            <p className="print-goalcard-faq-a">
              {t('goalsetter_description_title')}
            </p>
            <h3 className="print-goalcard-faq-q">
              {t('goalsetter_howtoredeem')}
            </h3>
            <p className="print-goalcard-faq-a">
              {executeAtDate ? t('goalcard_receiveto_title') : t('goalcard_sentto_title')}
              <span id="emailSend">{goalcard.receiverEmail}</span>
              {executeAtDate ? t('goalcard_claim_info2', { executeAtDate }) : t('goalcard_claim_info')}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrintGoalcard;
